var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Text from "../Text";
import React from 'react';
import { styled } from "../../utils";
var StyledContact = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    display: flex;\n    flex-direction: column;\n  }\n"], ["\n  && {\n    display: flex;\n    flex-direction: column;\n  }\n"])));
var ContactDesktop = function (_a) {
    var label = _a.label, phone = _a.phone, phoneHref = _a.phoneHref;
    return (React.createElement(StyledContact, { "data-component": "ContactDesktop", href: "tel:".concat(phoneHref || phone) },
        React.createElement(Text, { fontWeight: "medium" }, label),
        React.createElement(Text, { fontSize: "large", fontWeight: "bold" }, phone)));
};
export default ContactDesktop;
var templateObject_1;
//# sourceMappingURL=ContactDesktop.js.map